import axios from 'axios'
import mUi from '../lib/mint-ui'
import wxServ from '../service/wxServ'
import cache from '../service/cacheServ'
let http = axios.create({
    // baseURL: 'http://localhost:7887/api/v1'
    baseURL: '/api/v1'
})
http.interceptors.request.use(function (config) {
    // const userBase = cache.get('user')
    // if (userBase) {
    //     config.headers.AuthorizationId = userBase.id
    //     config.headers.Authorization = userBase.wxToken
    // }
    return config
}, function (error) {
    return Promise.reject(error)
})

http.interceptors.response.use(function (response) {
    if (response.data.code === '40029') {
        mUi.Toast({
            message: '登录过期，即将重新登录',
            position: 'bottom'
        })
        cache.set('user', '', true)
        setTimeout(function () {
            wxServ.getCode(0)
        }, 200)
    }

    return response.data
}, function (error) {
    mUi.Toast({
        message: '服务器开小差，请稍后再试',
        position: 'bottom'
    })
    return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/service/httpServ.js